<!-- <div class="container" *ngIf="pucg == 0">


  <div class="outer-box" *ngIf="step == 1 && his != 'history'">
    <div *ngIf="promo == 1" class="col-md-12" [class.order-first]="promo == 1">
      <div
        class="my-5 py-4 px-5 bg-light d-sm-flex align-items-center justify-content-between border border-success"
        (click)="options = 'PROMO'; pucg = 1"
      >
        <div class="text-center">
          <span style="font-weight: 600">
            <div class="icon-outer">
              <i
                class="fa fa-product-hunt"
                style="font-size: 70px; color: burlywood"
              ></i>
            </div>
            PROMO
          </span>
          <h4 class="my-2 font-weight-bold">$1,000 - 2,999</h4>
          <small class="text-uppercase text-secondary">4 days</small>
        </div>
        <div class="text-center text-uppercase text-secondary mb-2">
          <small class="d-block my-3" style="font-weight: 600"
            >400% interest in 4 days</small
          >
            <small class="d-block my-3" style="font-weight: 600;">10GB Bandwidth</small>
          <small class="d-block" style="font-weight: 600">24/7 Support</small>
        </div>
      </div>

      <div
        class="my-5 py-4 px-5 bg-light d-sm-flex align-items-center justify-content-between border border-success"
        (click)="options = 'SPECIAL PROMO'; pucg = 1"
      >
        <div class="text-center">
          <span style="font-weight: 600">
            <div class="icon-outer">
              <i
                class="fa fa-product-hunt"
                style="font-size: 70px; color: teal"
              ></i>
            </div>
            SPECIAL PROMO</span
          >
          <h4 class="my-2 font-weight-bold">$3,000 - 9,999</h4>
          <small class="text-uppercase text-secondary">4 days</small>
        </div>
        <div class="text-center text-uppercase text-secondary mb-2">
          <small class="d-block my-3" style="font-weight: 600"
            >4 days 400% + 5000</small
          >
            <small class="d-block my-3" style="font-weight: 600;">10GB Bandwidth</small>
          <small class="d-block" style="font-weight: 600">24/7 Support</small>
        </div>
      </div>

      <div
        class="my-5 py-4 px-5 bg-light d-sm-flex align-items-center justify-content-between border border-success"
        (click)="options = 'PROMO PRO'; pucg = 1"
      >
        <div class="text-center">
          <span style="font-weight: 600">
            <div class="icon-outer">
              <i
                class="fa fa-product-hunt"
                style="font-size: 70px; color: gold"
              ></i>
            </div>
            PROMO GOLD</span
          >
          <h4 class="my-2 font-weight-bold">Above $10,000</h4>
          <small class="text-uppercase text-secondary">4 days</small>
        </div>
        <div class="text-center text-uppercase text-secondary mb-2">
          <small class="d-block my-3" style="font-weight: 600"
            >400% (+ 15000) 4 days</small
          >
            <small class="d-block my-3" style="font-weight: 600;">10GB Bandwidth</small>
          <small class="d-block" style="font-weight: 600">24/7 Support</small>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="pricing-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp">
        <div class="inner-box">
          <div class="icon-box">
            <div class="icon-outer"><i class="fa fa-paper-plane"></i></div>
          </div>
          <div class="price-box">
            <div class="title">Aquila</div>
            <h4 class="price">$25 - $249</h4>
          </div>
          <ul class="features">
            <li class="true">1 day</li>
            <li class="true">+12% Growth</li>
            <li class="true" style="font-weight: bold; font-size: 15px">
              <strong v-if="aqui">{{ 1200 + aqui }} Investor(s)</strong>
            </li>
          </ul>
          <div class="btn-box" (click)="options = 'AQUI'; pucg = 1">
            <a href="javascript:void(0);" class="theme-btn">BUY plan</a>
          </div>
        </div>
      </div>

      <div class="pricing-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp">
        <div class="inner-box">
          <div class="icon-box">
            <div class="icon-outer"><i class="fa fa-paper-plane"></i></div>
          </div>
          <div class="price-box">
            <div class="title">Orion</div>
            <h4 class="price">$250 - $999</h4>
          </div>
          <ul class="features">
            <li class="true">3 days</li>
            <li class="true">+30% Growth</li>
            <li class="true" style="font-weight: bold; font-size: 15px">
              <strong v-if="oron">{{  3000 + oron }} Investor(s)</strong>
            </li>
          </ul>
          <div class="btn-box" (click)="options = 'ORON'; pucg = 1">
            <a href="javascript:void(0);" class="theme-btn">BUY plan</a>
          </div>
        </div>
      </div>


      <div
        class="pricing-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
        data-wow-delay="400ms"
      >
        <div class="inner-box">
          <div class="icon-box">
            <div class="icon-outer"><i class="fa fa-diamond"></i></div>
          </div>
          <div class="price-box">
            <div class="title">Bellatrix</div>
            <h4 class="price">$1000.99 - 9999</h4>
          </div>
          <ul class="features">
            <li class="true">5 days</li>
            <li class="true">+100% Growth</li>
            <li class="true" style="font-weight: bold; font-size: 15px">
              <strong v-if="bela">{{  4850 + bela }} Investor(s)</strong>
            </li>
          </ul>
          <div class="btn-box" (click)="options = 'BELA'; pucg = 1">
            <a href="javascript:void(0);" class="theme-btn">BUY plan</a>
          </div>
        </div>
      </div>


      <div
        class="pricing-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
        data-wow-delay="800ms"
      >
        <div class="inner-box">
          <div class="icon-box">
            <div class="icon-outer"><i class="fa fa-rocket"></i></div>
          </div>
          <div class="price-box">
            <div class="title">Sirius</div>
            <h4 class="price">$10000 - unlimited</h4>
          </div>
          <ul class="features">
            <li class="true">10 days</li>
            <li class="true">200% Growth</li>
            <li class="true" style="font-weight: bold; font-size: 15px">
              <strong v-if="siri">{{  8430 + siri }} Investor(s)</strong>
            </li>
          </ul>
          <div class="btn-box" (click)="options = 'SIRI'; pucg = 1">
            <a href="javascript:void(0);" class="theme-btn">BUY plan</a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-5 py-3 px-3 bg-light">
      <div
        class="d-sm-flex align-items-center justify-content-between"
        (click)="options = 'CIPs'; pucg = 1"
        style="cursor: pointer"
      >
        <div class="d-md-flex justify-content-between align-items-center">
          <div class="text-center">
            <p>
              <span class="text-primary">
                <img
                  src="https://www.uscis.gov/sites/default/files/images/site/DHS_cis_W.svg"
                  loading="lazy"
                  width="170px"
                  height="100px"
                  alt=""
                  class="sticky-card_icon"
                />
              </span>
            </p>
            <h4 class="mb-0 fw-200 text-center">
              Citizenship by Investment (CIPs)
            </h4>
          </div>
        </div>
        <div class="text-center text-uppercase text-secondary mb-2">
          <small class="d-block my-3" style="font-weight: 600"
            >Duration 1 month</small
          >
          <small class="d-block my-3" style="font-weight: 600" v-if="cip"
            >{{  2540 + cip }} Investor(s)</small
          >
          <small class="d-block" style="font-weight: 600">
            <div class="mt-10 mt-md-0">
              <a
                href="javascript:void(0);"
                class="waves-effect waves-light btn btn-outline btn-primary"
                >Invest Now</a
              >
            </div>
          </small>
        </div>
      </div>
      <hr />
      <div class="d-md-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-start align-items-center">
          <div class="min-w-100">
            <p class="mb-0 text-fade">Fund Size</p>
            <h6 class="mb-0">$10,000 - 50,000</h6>
          </div>
          <div class="mx-lg-50 mx-20 min-w-70">
            <p class="mb-0 text-fade">Return</p>
            <h6 class="mb-0 text-success">
              +500% <span class="text-dark">(1 month)</span>
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div *ngIf="pucg == 1">
  <div class="" *ngIf="bank == '0'">
    <div class="container">
      <div class="card">
        <div class="card-body">
          <div class="buy-sell-widget">


            <form
              (ngSubmit)="calculate(so)"
              #so="ngForm"
              *ngIf="bank == '0'"
              class="currency_validate"
              novalidate="novalidate"
            >

            <div class="payment-wrapper">
                <label class="section-title">Investment ($)</label>

                 <div class="input-group">
                  <input
                    type="number"
                    [(ngModel)]="amount"
                    name="deposit"
                    [readonly]="options === 'special'"
                    required
                    (input)="atLeastOneRadio()"
                    class="form-control form-control-amount form-control-lg blue-light-background"
                    id="custom-amount"
                    placeholder="minimum amount {{ amount }}"
                  />
                </div>
            </div>




                 <div class="payment-wrapper">
                  <label class="section-title">Select Payment Method</label>

                  <select
                    class="form-control payment-select"
                    name="spend"
                    [(ngModel)]="selectedPayment"
                    required
                  >
                    <option value="" disabled>Select a payment method</option>

                    <option
                      *ngFor="let method of paymentMethods"
                      [value]="method.value"
                    >
                      {{ method.label }}
                    </option>

                  </select>
                </div>


              <div class="payment-wrapper">

                <label class="section-title">Preview</label>


                <div
                  class="d-flex justify-content-between mt-3 mb-4"
                  *ngIf="money === 0 && gram !== null"
                >
                  <p class="mb-0">Buy: {{ amount | currency }}</p>
                  <h6 class="mb-0">Gram: {{ gram }}</h6>
                </div>
              </div>

              <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="money == 0">
                <button
                  type="submit"
                  class="btn btn-success btn-round btn-block"
                  *ngIf="display == 0"
                  [disabled]="!chek()"
                >
                  Buy Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="bank == '2'">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="row justify-content-center">
            <div class="col-md-12 mb-3">
              <div class="card shadow-lg">
                <div class="rounded-bottom card-body text-white">
                  <p class="opacity-75 text-center">
                    Send {{ amountTopay }} to the details below
                  </p>
                  <input
                    type="text"
                    id="address"
                    class="form-control form-control-lg mt-2 mb-2"
                    [value]="addressTopay"
                    id="refUrl"
                    readonly=""
                  />

                  <input
                    type="text"
                    id="address"
                    class="form-control form-control-lg mt-2 mb-2"
                    [value]="upID"
                    id="refUrl"
                    readonly=""
                    *ngIf="upID"
                  />
                  <button
                    class="btn btn-primary btn-block btn-lg my-link-copy mb-2"
                    data-clipboard-target="#my-link-m"
                    (click)="copy()"
                  >
                    COPY
                  </button>
                  <div class="rounded p-3 bg-white-translucent">
                    <p class="font-size-sm mb-0" style="color: black" *ngIf="tic == 'UPI'">
                      <span class="text-primary">ATTENTION</span> - Please send
                      {{ amountTopay }} worth of Rupee through {{ tic }}
                    </p>

                    <p class="font-size-sm mb-0" style="color: black" *ngIf="tic != 'UPI'">
                      <span class="text-primary">ATTENTION</span> - Please send
                      {{ amountTopay }} worth of {{ tic }} to the above address through your wallet.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="bank == '1' && country == 'India'">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div *ngFor="let item of banks">
            <div class="row justify-content-center">
              <div class="col-md-12 mb-3">
                <div class="card shadow-lg">
                  <div class="rounded-bottom card-body text-white">
                    <label for="">Bank name</label>
                    <input
                      type="text"
                      id="address"
                      class="form-control form-control-lg mt-2 mb-2"
                      [value]="item.Bank"
                      readonly=""
                    />
                    <label for="">Account number</label>
                    <input
                      type="text"
                      id="address"
                      class="form-control form-control-lg mt-2 mb-2"
                      [value]="item.Account"
                      readonly=""
                    />
                    <label for="">Account name</label>
                    <input
                      type="text"
                      id="address"
                      class="form-control form-control-lg mt-2 mb-2"
                      [value]="item.Accountname"
                      readonly=""
                    />
                    <label for="">IFSC CODE</label>
                    <input
                      type="text"
                      id="address"
                      class="form-control form-control-lg mt-2 mb-2"
                      [value]="item.branch"
                      readonly=""
                    />
                    <label for="">Amount</label>
                    <input
                      type="text"
                      id="address"
                      class="form-control form-control-lg mt-2 mb-2"
                      [value]="amm"
                      readonly=""
                    />

                    <div class="rounded p-3 bg-white-translucent">
                      <!--    <p class="font-size-sm mb-0" style="background-color: black;">
                        <span class="text-primary">ATTENTION</span> -After Payment, contact the adminstrator with your
                        proof
                        of payment or<b><a style="text-decoration: underline;"
                            href="javascript:void(Tawk_API.toggle())">Live
                            Chat</a></b> for
                        quick response
                      </p> -->

                      <p style="background-color: black">
                        * For easy confirmation make payments with this
                        paymentID
                        <b
                          ><em style="color: white">{{ rand }}</em></b
                        >
                        on your bank teller
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
